import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {IndexPage} from '../IndexPage/IndexPage'
import {Category} from '../articles/Category/Category'
import {isIndexPayload} from '../../lib/types/generic-payload'
import {isCategoryPayload} from '../../lib/types/payload'

/**
 * Temporary component to handle template-based routing for the /resources/articles route.
 * This component conditionally renders either IndexPage or Category based on the
 * payload type that successfully parses, making it backwards compatible.
 *
 * TODO: Remove this component once all pages have migrated to the new Index template.
 */
export function TemporaryIndex() {
  const routePayload = useRoutePayload<unknown>()

  // Check CategoryPayload first because it requires specific fields (pageHeading, page)
  // that IndexPayload doesn't have, preventing false positives
  if (isCategoryPayload(routePayload)) {
    return <Category />
  }

  if (isIndexPayload(routePayload)) {
    return <IndexPage />
  }

  return <Category />
}

try{ TemporaryIndex.displayName ||= 'TemporaryIndex' } catch {}